module.exports = __webpack_public_path__ + "img/Message.91b5cabd.svg";